import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useNavState } from '@/common/navState/NavStateContext';
import { ValList } from '@/common/val/ValList';
import { McdDispList } from '../mcdDisp/McdDispList';

export const McdLedgerLineDetail = () => {
  const { entityObj } = useEntityMgr();
  const { navState } = useNavState();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'ledger', label: 'Ledger', content: <EntityForm entity="MCD_LEDGER" entityId={entityObj.mcdLedgerId} /> },
    {
      id: 'val',
      label: 'Validations',
      content: <ValList parentEntity="MCD_LEDGER_LINE" parentEntityId={entityObj.id} partition={navState.partition} />,
    },
    {
      id: 'disps',
      label: 'Disputes',
      content: <McdDispList mcdLedgerLineId={entityObj.id} partition={navState.partition} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
